import { Box } from '@chakra-ui/layout'
import { connectNetwork } from 'lib/NetworkProvider'
import View from 'lib/View'
import moment from 'momentconfig'
import React, { Component } from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router'
import { Placeholder } from 'semantic-ui-react'
import { BabypressaData, CustomTable } from '../components'
import { baseViewDispatch, initializePage } from '../lib/util'
class BabyPressa extends Component {
    constructor(props) {
        super(props)

        this.state = {
            start: moment().subtract(1, 'day'),
            end: moment(),
        }
    }

    prev() {
        // todo moment subtract
    }

    next() {
        // todo moment add
    }

    componentDidMount() {
        let { sub, network } = this.props
        if (!sub) {
            initializePage(this, [], {})
        }

        let start = this.state.start.format('YYYY-MM-DD HH:mm:ss')
        let end = this.state.end.format('YYYY-MM-DD HH:mm:ss')

        // console.log('Start and end are:', start, end)

        network.getLastBabypressaData()
        network.getBabypressaData(start, end)
    }

    renderData(key, babypressadata) {
        return (
            <View fullw type="full" key={`babypressadata_${key}`}>
                {babypressadata.timestamp}
            </View>
        )
    }

    render() {
        let { fetching, babypressadatalist, getLastBabypressaData, ...rest } = this.props
        let content = <div />

        if (fetching) {
            let placeholders = []
            for (let i = 0; i < 3; i++) {
                placeholders.push(
                    <Box key={i} style={{ width: '100%', margin: 8 }}>
                        <Box textStyle="content">
                            <Placeholder>
                                <Placeholder.Header image>
                                    <Placeholder.Line />
                                    <Placeholder.Line />
                                </Placeholder.Header>
                                <Placeholder.Paragraph>
                                    <Placeholder.Line />
                                    <Placeholder.Line />
                                    <Placeholder.Line />
                                    <Placeholder.Line />
                                </Placeholder.Paragraph>
                            </Placeholder>
                        </Box>
                    </Box>
                )
            }
            content = (
                <View fullw column>
                    {placeholders}
                </View>
            )
        } else if (babypressadatalist.data) {
            // console.log('babypressadatalist is', babypressadatalist.data)

            content = <CustomTable name="BabypressaData" shorthand="babypressadata" values={babypressadatalist.data} child={BabypressaData} />
        }

        return (
            <View fullw fullh column style={{ paddingLeft: 20, paddingRight: 20 }} {...rest}>
                {content}
            </View>
        )
    }
}

const mapStateToProps = (state, ownProps) => {
    let { getLastBabypressaData, getBabypressaData } = state
    return {
        getLastBabypressaData,
        fetching: getBabypressaData.fetching,
        babypressadatalist: getBabypressaData.data,
        getBabypressaData,
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        ...baseViewDispatch(dispatch),
    }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(connectNetwork(BabyPressa)))
